import {
  TYPE_HMO,
  TYPE_PPO,
  TYPE_MEDICARE,
  TYPE_MEDICAID,
  TYPE_TRICARE,
  TYPE_OTHER,
  TYPE_UNKNOWN,
} from '../../../constants';

export default [
  { key: TYPE_HMO, label: 'HMO' },
  { key: TYPE_PPO, label: 'PPO' },
  { key: TYPE_MEDICARE, label: 'Medicare' },
  { key: TYPE_MEDICAID, label: 'Medicaid' },
  { key: TYPE_TRICARE, label: 'Tricare' },
  { key: TYPE_OTHER, label: 'Other' },
  { key: TYPE_UNKNOWN, label: "Don't know" },
];
